import {
    Box,
    Flex,
} from "@chakra-ui/react";

import {
    useEffect,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import ReferralStats from "./components/ReferralStats";
import PartnersTable from "./components/PartnersTable";

import {
    fetchReferredDriversAction,
    fetchReferralMilestonesAction,
} from "../../state/actions/driverPartnerActions";
import {
    fetchDriverByIdAction,
} from "../../state/actions/driverActions";
import { exportRecruitmentReport } from "../../reports_statements/recruitmentReport";

const Referrals = () => {
    const dispatch =
        useDispatch();
       const {
        driverPartner,
    } = useSelector(
        (state) =>
            state.driverPartner
    );
    const {
        referredDrivers,
        referralMilestones,
        loading,
    } = useSelector(
        (state) =>
            state.driverPartner
    );

    useEffect(() => {
        dispatch(
            fetchReferredDriversAction(
                1,
                10
            )
        );

        dispatch(
            fetchReferralMilestonesAction()
        );
    }, [
        dispatch,
    ]);
    useEffect(() => {
    referredDrivers
        .filter(
            recruit =>
                recruit.driver?.driver_id
        )
        .forEach(
            recruit => {
                dispatch(
                    fetchDriverByIdAction(
                        recruit.driver.driver_id
                    )
                );
            }
        );
}, [
    referredDrivers,
    dispatch,
]);

    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="My Recruits"
                        subtitle="Track your recruited drivers, milestone progress, and recruits earnings."
                        primaryLabel="Export Recruits"
                        primaryDisabled={
                            referredDrivers.length < 5
                        }
                        primaryDisabledTitle="Recruitment target not reached"
                        primaryDisabledMessage="To download recruitment reports you must recruit at least 5 drivers."
                        onPrimaryClick={() =>
                        exportRecruitmentReport(
                            driverPartner,
                            referredDrivers,
                            referralMilestones
                        )
                    }
                        
                    />

                    <ReferralStats
                        drivers={
                            referredDrivers
                        }
                        milestones={
                            referralMilestones
                        }
                    />

                    <PartnersTable
                        drivers={
                            referredDrivers
                        }
                        milestones={
                            referralMilestones
                        }
                        loading={
                            loading
                        }
                    />
                </Box>
            </Flex>
        </Flex>
    );
};

export default Referrals;